// ЯПОНСКИЙ ОРНАМЕНТ ФОНОМ БЛОКА.
//
// Два традиционных узора, нарисованных градиентами в CSS (src/index.css):
//   seigaiha — 青海波, «волны синего моря»: концентрические полукруги,
//              знак спокойствия и удачи. Под крупные секции;
//   asanoha  — 麻の葉, «лист конопли»: шестиугольная звёздчатая сетка,
//              традиционный оберег. Под узкие блоки и карточки.
//
// Почему отдельный слой, а не класс на самой карточке: узор растворяется к
// краям (mask-image), а маска действует и на содержимое элемента — текст
// вместе с орнаментом уходил бы в прозрачность. Поэтому узор лежит
// подложкой, а контент — над ним.
//
// Родителю нужны `relative` и `overflow-hidden`, иначе узор вылезет за
// скруглённые углы карточки.
export default function PatternLayer({ kind = "seigaiha", className = "" }) {
  return (
    <div
      aria-hidden="true"
      className={`pointer-events-none absolute inset-0 -z-0 pattern-${kind} pattern-fade ${className}`}
    />
  );
}
